module.exports = __webpack_public_path__ + "img/PK.f33c2297.svg";